var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({ background: _vm.$vuetify.theme.themes[_vm.theme].background })},[_c('snackBar'),_c('Loading',{attrs:{"active":_vm.isLoading,"color":_vm.color,"loader":_vm.loaderType,"is-full-page":false},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }